import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import combinedReducers from './reducers'
import { persistStore, persistReducer, PersistConfig } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const persistConfig = {
    key: 'root',
    storage,
    whitelist:['accessibility']
  }

const persistedReducer = persistReducer(persistConfig, combinedReducers)
const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middleware = [thunk];

export default () => {
    let store = createStore(persistedReducer, composeEnhancers(applyMiddleware(...middleware)))
    let persistor = persistStore(store)
    return { store, persistor }
}